module.exports = __webpack_public_path__ + "static/media/live-session.ad05ae6e.png";